<template>
<div class="email-item">
  <div class="email-item__info">
    <h3>{{ email.name }}</h3>
    <p>{{ email.note }}</p>
    <ul class="email-item__info--addresses">
      <li v-bind:key="address.index" v-for="address in email.addresses">
        <i class="el-icon-arrow-right"></i> {{ address }}
      </li>
    </ul>
  </div>
  <div class="email-item__space">
    <el-progress
      type="line"
      :text-inside="true"
      :percentage="spacePercentage"
      :stroke-width="16"
    >
    </el-progress>
    <p class="email-item__space--numbers">
      <span>{{ email.space.used }}</span> / {{ email.space.available }} MB used
    </p>
  </div>
  <div class="email-item__buttons">
    <el-button plain>Account settings</el-button>
    <el-button plain>Access data</el-button>
  </div>
  <el-menu class="email-item__dropdown" mode="horizontal">
    <el-submenu index="0" popper-class="email-item__dropdown--items">
      <template slot="title">
        <i class="el-icon-more"></i>
      </template>
      <el-menu-item index="1">Lock</el-menu-item>
      <el-menu-item index="2">Empty</el-menu-item>
      <el-menu-item index="3">Clear</el-menu-item>
    </el-submenu>
  </el-menu>
</div>
</template>
<script>
export default {
  props: ['email'],
  data: () => ({}),
  computed: {
    spacePercentage() {
      return Number(((this.email.space.used / this.email.space.available) * 100).toFixed(0));
    },
  },
};
</script>
<style lang="scss">
.email-item {
  margin-bottom: 0;
  padding: 25px;
  transition: background-color .3s ease;
  display: flex;
  justify-content: stretch;
  align-items: flex-start;

  &:hover {
    background-color: #FFFFFF;
  }

  div {
    flex: 1;
    text-align: left;
  }

  &__info {
    h3, p {
      margin-top: 0;
      margin-bottom: 5px;
    }

    h3 {
      font-size: 20px;
    }

    p {
      font-size: 16px;
      font-weight: 300;
    }

    &--addresses {
      margin-top: 10px;
      list-style: none;
      font-size: 14px;
    }
  }

  &__space {
    &--numbers {
      font-size: 12px;

      span {
        font-weight: 700;
      }
    }
  }

  &__buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .el-button {
      padding: 6px 16px;
      margin: 0;
      width: 150px;

      &+.el-button {
        margin-top: 5px;
        margin-left: 0;
      }
    }
  }

  &__dropdown {
    position: absolute;
    top: 0;
    right: 0;
    border: none !important;
    background-color: transparent !important;

    &--items {
      width: 150px;
    }

    .el-submenu {
      &.is-opened {
        position: relative;
        z-index: 20;
      }

      &__icon-arrow {
        display: none;
      }

      .el-icon-more {
        position: absolute;
        right: 20px;
        top: 26px;
      }

      &__title,
      &__title:hover {
        background-color: transparent !important;
      }
    }

    .is-opened {
      z-index: 10;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/EmailItem.vue